import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard". Copies textValue to the clipboard,
// swaps the icon to a checkmark briefly, and surfaces the global toast.
export default class extends Controller {
    static targets = ["icon", "check"]
    static values = { text: String }

    async copy(e) {
        e.preventDefault()

        try {
            await navigator.clipboard.writeText(this.textValue)
        } catch (error) {
            window.toast("Couldn't copy the link", { kind: "alert" })
            return
        }

        window.toast("Link copied to clipboard")

        clearTimeout(this.revertTimeout)
        this.iconTarget.classList.add("hidden")
        this.checkTarget.classList.remove("hidden")
        this.revertTimeout = setTimeout(() => {
            this.checkTarget.classList.add("hidden")
            this.iconTarget.classList.remove("hidden")
        }, 2000)
    }
}
